/* eslint-disable no-promise-executor-return */
/**
 * Asynchronous wait function that returns a Promise.
 *
 * Optionally pass in an instance of Error as the second argument (useful for simulating err handling)
 * @param {number} ms How long to wait in ms
 * @param {Error} [error] Handles rejection!
 * @returns {Promise} Promise
 */
export default function wait(ms, error = null) {
  return new Promise((resolve, reject) => {
    if (error) {
      return setTimeout(() => reject(error), ms);
    }
    return setTimeout(resolve, ms);
  });
}
